var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 12.375C13.2063 12.375 14.4375 11.1438 14.4375 9.625C14.4375 8.10622 13.2063 6.875 11.6875 6.875C10.1687 6.875 8.9375 8.10622 8.9375 9.625C8.9375 11.1438 10.1687 12.375 11.6875 12.375Z",
    stroke: "#3B4443",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6.1875H4.8125",
    stroke: "#3B4443",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11H4.8125",
    stroke: "#3B4443",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15.8125H4.8125",
    stroke: "#3B4443",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 14.4375C8.04279 13.7971 8.66558 13.2773 9.38155 12.9194C10.0975 12.5614 10.887 12.375 11.6875 12.375C12.488 12.375 13.2775 12.5614 13.9934 12.9194C14.7094 13.2773 15.3322 13.7971 15.8125 14.4375",
    stroke: "#3B4443",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 18.5625V3.4375C18.5625 3.0578 18.2547 2.75 17.875 2.75L5.5 2.75C5.1203 2.75 4.8125 3.0578 4.8125 3.4375L4.8125 18.5625C4.8125 18.9422 5.1203 19.25 5.5 19.25H17.875C18.2547 19.25 18.5625 18.9422 18.5625 18.5625Z",
    stroke: "#3B4443",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne9);
export default __webpack_public_path__ + "static/media/footer-one-9.e95ecb10d42630cbc420bcb1b298a8fd.svg";
export { ForwardRef as ReactComponent };